import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ItemDTO } from '../../../../../../models/item.model';
import { ItemsService } from '../../../../../../services/financeiro/item.service';
import { PessoaDTO } from '../../../../../../models/clientes/pessoa.model';
import { ItemDeNotaDTO } from '../../../../../../models/nota.model';
import {
  TimbradoDTO,
  TimbradoFormDTO,
} from '../../../../../../models/configuracoes/timbrao.model';
import { TipoTransacao } from '../../../../../../enums/TipoTransacao.enum';
import { TipoPadraoNota } from '../../../../../../enums/TipoPadraoNota.enum';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';
import { TimbradoService } from '../../../../../../services/configuracoes/timbrado.service';
import { Router } from '@angular/router';

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}

@Component({
  selector: 'app-produto-adicionar',
  templateUrl: './produto-adicionar.component.html',
  styleUrls: ['./produto-adicionar.component.scss'],
})
export class AdicionarItemComponent {
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() selectedFornecedor = new EventEmitter<PessoaDTO>();
  @Input() pessoaId: number | undefined;
  @Output() selectedItem = new EventEmitter<ItemDTO>();

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private timbradoService: TimbradoService,
    private router: Router
  ) {}

  ngOnInit() {}

  getDropItems(enumType: object): { label: string; value: string }[] {
    return Object.values(enumType).map((item) => ({
      label: String(item),
      value: String(item).toUpperCase(),
    }));
  }
}
